import DropSelect from "components-new/DropSelect";
import { Button, SortBy } from "components/shared";
import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as ActionIconSvg } from "images/ActionMenuIcon.svg";
import { ReactComponent as ArchiveIconSvg } from "images/archive.svg";
import { StaffTable } from "components/StaffTable/StaffTable";
import useDebounce from "hooks/useDebounce";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { Search } from "components-new";
import { getOrganizationsName } from "toolkit/employees/employees.thunks";

import "pages/References/StaffPage/StaffPage.styles.sass";
import StepInfo from "pages/StepPages/components";
import sass from "pages/References/AreasOfActivity/areasActivity.module.sass";
import { BUTTON_VARIANTS } from "../../../components/shared/Button/Button";
import {organizationsAPI} from "../../../libs/apiClient/Organizations";
import {userAPI} from "../../../libs/apiClient/User";

export const StaffPage: FC = () => {
	const dispatch = useAppDispatch();

	const location = useLocation();
	// const locationOrgId = location.search.replace(/\?org=(\d+)/g, "$1");
	// console.log(locationOrgId);
	const navigate = useNavigate();

	const state = useLocation().state;

	const archive = useMemo(() => {
		return /\/archive$/.test(location.pathname);
	}, [location.pathname]);

	const select = useMemo(() => {
		return /\/select$/.test(location.pathname);
	}, [location.pathname]);

	const [addingEmployee, setAddingEmployee] = useState<boolean>(false);
	const [searchValue, setSearchValue] = useState<string>("");
	const debouncedValue = useDebounce(searchValue, 400);

	const [currentOrg, setCurrentOrg] = useState<{ name: string | null; text: string }>({
		name: null,
		text: "Все компании",
	});

	const orgNames = useAppSelector((state) => state.employess.organizationsName);

	const [orgNamesLong, setOrgNamesLong] = useState<any[]>([]);
	useEffect(() => {
		(async () =>
			organizationsAPI.getOrganizations({archived:false}).then((r) => {
				setOrgNamesLong(r.data);
			}))();
	}, []);

	const [actionsVisible, setActionsVisible] = useState<boolean>(false);
	const actionsRef = useRef<any>(null);

	useEffect(() => {
		if (state?.from === "employee") {
			setAddingEmployee(true);
		}
		//eslint-disable-next-line
	}, []);

	useEffect(() => {
		dispatch(getOrganizationsName());
		//eslint-disable-next-line
	}, []);

	useEffect(() => {
		setCurrentOrg(orgNames[0]);
	}, [orgNames]);

	const selectOrgId = useMemo(() => {
		const indexQuery = location.search.replace(/\D+/g, "");
		if (indexQuery) return Number(indexQuery);
		return null;
	}, [location.search]);
	useEffect(() => {
		function handleClickOutside(event: any) {
			if (actionsRef.current && !actionsRef.current.contains(event.target)) {
				setTimeout(() => {
					setActionsVisible(false);
				}, 0);
			}
		}

		document.addEventListener("mouseup", handleClickOutside);
		return () => {
			document.removeEventListener("mouseup", handleClickOutside);
		};
		//eslint-disable-next-line
	}, [actionsRef.current, archive]);

	useEffect(() => {
		if (orgNames.length) {
			if (selectOrgId) {
				const org = orgNames.find((_) => _.name === selectOrgId);
				org && setCurrentOrg(org);
			}
		}
		//eslint-disable-next-line
	}, [selectOrgId, orgNames, selectOrgId]);

	const outlineStyle = useCallback(
		(id: number) => {
			return location.state && location.state.outline && location.state.outline === id ? sass.outline : "";
		},
		[location],
	);
	useEffect(() => {
		let replacedLocation = location.search;
		if (/\?org=/.test(replacedLocation)) {
			if (/\?org=\d+/.test(replacedLocation)) {
				replacedLocation = replacedLocation.replace(/(\?org=)\d+/g, `$1${(currentOrg?.name ?? selectOrgId) || ""}`);
			} else {
				replacedLocation += (currentOrg?.name ?? selectOrgId) || "";
			}
		} else {
			replacedLocation += `?org=${(currentOrg?.name ?? selectOrgId) || ""}`;
		}
		// if (!currentOrg.name) {
		// 	replacedLocation = replacedLocation.replace(/\?org=\d+/, "");
		// }
		navigate(replacedLocation, { replace: true, state: location.state });
		//eslint-disable-next-line
	}, [currentOrg]);

	const [disabled, setDisabled] = useState(false);
	useEffect(() => {
		userAPI.permissionsCheckCreate(0, ["system.employee.create"])
			.then((r) => setDisabled(!r.data.length));
	}, []);
	return (
		<div className="step-wrapper">
			<div className="step-header">
				{/*<h3 className="staff-title">Справочник сотрудников</h3>*/}
				<StepInfo
					info={archive ? "Архив справочника сотрудников" : select ? "Выберите сотрудника" : "Справочник сотрудников"}
				/>
				<div className="staff-heading-wrp">
					<div className="staff-sort">
						<SortBy
							options={orgNames}
							selectedOption={currentOrg || { name: null, text: "Все компании" }}
							setSelectedOption={(e: any) => setCurrentOrg(e)}
						/>
					</div>

					<Search
						className="staff-search"
						handleSearch={(e) => setSearchValue(e.target.value)}
						searchValue={searchValue}
					/>
					{!archive && (
						<>
							<Button disabled={disabled} variant={BUTTON_VARIANTS.CONTAINED} onClick={() => setAddingEmployee(true)}>
								Добавить сотрудника
							</Button>
							<ActionIconSvg
								className="staff-iconActions"
								ref={actionsRef}
								onClick={() => setActionsVisible(!actionsVisible)}
							/>
							{actionsVisible && (
								<DropSelect target={actionsRef.current} position="right">
									<div className="staff-dropDown">
										{/*<button className="staff-table-action-menu-btn">*/}
										{/*  <ImportIconSvg className="staff-table-importIcon" />*/}
										{/*  Импорт*/}
										{/*</button>*/}
										<Link to="archive" state={location.state}>
											<button className="staff-table-action-menu-btn">
												<ArchiveIconSvg className="staff-table-archiveIcon" />
												Архив
											</button>
										</Link>
									</div>
								</DropSelect>
							)}
						</>
					)}
				</div>
			</div>
			<StaffTable
				archive={archive}
				outline={outlineStyle}
				select={select}
				orgs={orgNames}
				addingOrgs={orgNamesLong}
				addingEmployee={addingEmployee}
				query={(debouncedValue as string) || ""}
				setAddingEmployee={setAddingEmployee}
			/>
		</div>
	);
};
